

import React, { useState } from "react";
import styles from "./StandingOrder.module.css";
import { InputField, SubmitButton, TextComponent } from "../../../../../components";
import { ReactComponent as EditIcon } from "../../../../../assets/images/editIcon.svg";
import { FiSearch } from "react-icons/fi";
import { IoCloseCircleOutline, } from "react-icons/io5";
import { CiSquareMinus } from "react-icons/ci";
import { VscDiffAdded } from "react-icons/vsc";
import HeadingComponent from "../../../../../components/HeadingComponent/HeadingComponent";
import { IoSaveOutline } from "react-icons/io5";
import Switch from "../../../../../components/Switch/Switch";



const StandingOrder = () => {
  const [edit, setEdit] = useState(false);
  const [activeStatus, setActiveStatus] = useState();
  const [updateDate, setUpdateDate] = useState("");

  console.log("activeStatus", activeStatus);

  const handleOrderStatusChange = (dayIndex, isChecked) => {
    const updated = [...orders];
    updated[dayIndex].status = isChecked ? "active" : "inactive";
    setOrders(updated);
  };
  const [orders, setOrders] = useState([
    {
      day: "Monday",
      time: "12:14 PM",
      startDateTime: "Aug 25, 2025 12:14 PM",
      status: "active",
      products: [
        { name: "French Baguette", quantity: 1 },
        { name: "Ciabatta", quantity: 2 },
        { name: "Sourdough Loaf", quantity: 3 },
        { name: "Sourdough Loaf", quantity: 3 },


      ],
    },
    {
      day: "Tuesday",
      time: "01:00 PM",
      startDateTime: "Aug 26, 2025 01:00 PM",
      status: "inactive",
      products: [
        { name: "Whole Wheat Bread", quantity: 2 },
        { name: "Croissant", quantity: 4 },
      ],
    },
    {
      day: "Wednesday",
      time: "10:30 AM",
      startDateTime: "Aug 27, 2025 10:30 AM",
      status: "active",
      products: [
        { name: "Brioche Bun", quantity: 3 },
        { name: "Bagel", quantity: 5 },
      ],
    },
    {
      day: "Thursday",
      time: "02:00 PM",
      startDateTime: "Aug 28, 2025 02:00 PM",
      status: "active",
      products: [
        { name: "Multigrain Bread", quantity: 1 },
        { name: "Pretzel", quantity: 2 },
      ],
    },
    {
      day: "Friday",
      time: "11:45 AM",
      startDateTime: "Aug 29, 2025 11:45 AM",
      status: "inactive",
      products: [
        { name: "Baguette", quantity: 4 },
        { name: "Dinner Roll", quantity: 6 },
      ],
    },
    {
      day: "Saturday",
      time: "09:15 AM",
      startDateTime: "Aug 30, 2025 09:15 AM",
      status: "active",
      products: [
        { name: "Focaccia", quantity: 2 },
        { name: "Donut", quantity: 12 },
      ],
    },
    {
      day: "Sunday",
      time: "03:30 PM",
      startDateTime: "Aug 31, 2025 03:30 PM",
      status: "inactive",
      products: [
        { name: "Pita Bread", quantity: 5 },
        { name: "Garlic Bread", quantity: 3 },
      ],
    },
  ]);


  const handleToggleEdit = () => setEdit((prev) => !prev);
  //   const handleToggleEdit = (dayIndex) => {
  //   setUpdateDate(orders[dayIndex].time);
  //   setUpdateDate(orders?.time);   
  //   setEdit(prev => !prev);
  // };


  const handleAddProduct = (dayIndex) => {
    const updated = [...orders];
    updated[dayIndex].products.push({ name: "", quantity: 1 });
    setOrders(updated);
  };

  const handleRemoveProduct = (dayIndex, productIndex) => {
    const updated = [...orders];
    updated[dayIndex].products.splice(productIndex, 1);
    setOrders(updated);
  };

  const handleAddQuantity = (dayIndex, productIndex) => {
    const updated = [...orders];
    updated[dayIndex].products[productIndex].quantity += 1;
    setOrders(updated);
  };

  const handleDeleteQuantity = (dayIndex, productIndex) => {
    const updated = [...orders];
    const product = updated[dayIndex].products[productIndex];
    if (product.quantity > 1) product.quantity -= 1;
    setOrders(updated);
  };

  const handleChangeProduct = (dayIndex, productIndex, value) => {
    const updated = [...orders];
    updated[dayIndex].products[productIndex].name = value;
    setOrders(updated);
  };

  return (
    <div className={styles.mainContainer}>

      <div className={styles.editIconContainer} onClick={handleToggleEdit}>
        {edit ?
          <IoSaveOutline className={styles.editIcon} />
          :
          <EditIcon className={styles.editIcon} />
        }
      </div>

      <div className={styles.container}>
        {orders.map((order, dayIndex) => (
          <div
            key={dayIndex}
            className={styles.card}
            style={{
              backgroundColor: "#fff",
              borderRadius: "12px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              padding: "10px",
              filter: order.status === "inactive" && !edit ? "blur(1px)" : "none",
              opacity: order.status === "inactive" && !edit ? 0.5 : 1,
              width: "100%",
            }}
          >
            <div className={styles.dayrow}>
              <TextComponent text={order.day} className={styles.SubHeading} />
              {edit ? (
                <InputField
                  inputStyle={{
                    backgroundColor: "#f7f8f9b9",
                    // marginTop: "0px",
                    // marginBottom: "10px",
                    // maxHeight: "20px",
                    margin: "0px auto",
                    maxWidth: "150px",
                  }}
                  innerInput={{
                    backgroundColor: "#f7f8f9b9",
                  }}
                  className={styles.inputStyle}
                  // placeholder="Product Name"
                  //  value={updateDate}
                  //  onChange={(e) => setUpdateDate(e.target.value)}
                  value={order.time}
                  onChange={(e) => {
                    const updated = [...orders];
                    updated[dayIndex].time = e.target.value;
                    setOrders(updated);
                  }}

                />
              ) : (
                <TextComponent
                  text={order.time}
                  className={styles.Card_Text}
                />
              )}

              {edit && (
                <Switch
                  activeColor={"#F39C12"}
                  inactiveColor={" #78788029"}
                  size="small"
                  isChecked={order.status === "active"}
                  onChange={(val) => handleOrderStatusChange(dayIndex, val)}
                  SwitchContainerStyle={styles.switchButton}
                />
              )}
            </div>

            <div style={{ marginTop: "10px" }}>
              <TextComponent
                text="Production Start Date & Time"
                className={styles.SubHeading}
              />
              <TextComponent
                text={order.startDateTime}
                className={styles.Card_Text}
                style={{ marginTop: "5px" }}
              />
            </div>

            {!edit && (
              <div className={styles.productSection}>
                <div style={{ marginRight: "10px" }} >
                  <div className={styles.row}>
                    <TextComponent
                      text="Product"
                      className={styles.SubHeading}
                    />
                    <TextComponent
                      text="Quantity"
                      className={styles.SubHeading}
                    />
                  </div>

                  {order.products.map((product, i) => (
                    <div key={i} className={styles.row}>
                      <TextComponent
                        text={product.name}
                        className={styles.Card_Text}
                      />
                      <TextComponent
                        text={product.quantity.toString()}
                        className={styles.Card_Text}
                      />
                    </div>
                  ))}
                </div>
              </div>
            )}


            {edit && (
              <div className={styles.ProductContainer}
              >
                {order.products.map((product, productIndex) => (
                  <div key={productIndex} className={styles.editProductSection}>
                    <div className={styles.row}>
                      <HeadingComponent
                        fontSize={"var(--mobile-subheading)"}
                        text={`Product ${productIndex + 1}`}
                        padding={"0px"}
                        className={styles.productHeading}
                      />
                      <IoCloseCircleOutline
                        cursor={"pointer"}
                        onClick={() =>
                          handleRemoveProduct(dayIndex, productIndex)
                        }
                      />
                    </div>

                    <div className={styles.Box}>
                      <div className={styles.Inputrow}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                          }}
                        >
                          <FiSearch
                            color={"#808080"}
                            style={{ marginBottom: "10px" }}
                          />
                          <InputField
                            inputStyle={{
                              backgroundColor: "#F7F8F9",
                              border: "none",
                              marginTop: "0px",
                              marginBottom: "10px",
                              maxHeight: "20px",
                            }}
                            innerInput={{
                              backgroundColor: "#F7F8F9",
                              border: "none",
                            }}
                            className={styles.inputStyle}
                            placeholder={"Product Name"}
                            value={product.name}
                            onChange={(e) =>
                              handleChangeProduct(
                                dayIndex,
                                productIndex,
                                e.target.value
                              )
                            }
                          />
                        </div>

                        <div className={styles.CounterDiv}>
                          <CiSquareMinus
                            cursor={"pointer"}
                            onClick={() =>
                              handleDeleteQuantity(dayIndex, productIndex)
                            }
                          />
                          <TextComponent
                            text={product.quantity.toString()}
                            color={"#808080"}
                            padding={"0px"}
                          />
                          <VscDiffAdded
                            cursor={"pointer"}
                            onClick={() =>
                              handleAddQuantity(dayIndex, productIndex)
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                ))}

                <div className={styles.AddProductButtonContainerClass}>
                  <SubmitButton
                    title={"Add"}
                    secondary
                    btnClass={styles.AddProductButton}
                    onClick={() => handleAddProduct(dayIndex)}
                  />
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default StandingOrder;
